import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Profile() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  if (!user) {
    return (
      <div className="text-center py-10">
        <h2 className="text-2xl font-semibold">
          Please Login First
        </h2>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8">
        <div className="flex flex-col md:flex-row items-center gap-6">
          <img
            src={`https://ui-avatars.com/api/?name=${user.name}`}
            alt="profile"
            className="w-24 h-24 rounded-full"
          />

          <div>
            <h1 className="text-3xl font-bold">
              {user.name}
            </h1>
            <p className="text-gray-600">
              {user.email}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mt-8">
          <div className="border rounded-lg p-4">
            <h3 className="font-semibold">
              Name
            </h3>
            <p>{user.name}</p>
          </div>

          <div className="border rounded-lg p-4">
            <h3 className="font-semibold">
              Email
            </h3>
            <p>{user.email}</p>
          </div>

          <div className="border rounded-lg p-4">
            <h3 className="font-semibold">
              Phone
            </h3>
            <p>{user.phone}</p>
          </div>

          <div className="border rounded-lg p-4">
            <h3 className="font-semibold">
              Role
            </h3>
            <p>{user.role}</p>
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="mt-8 bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-lg"
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default Profile;